import React, { ButtonHTMLAttributes, ReactNode } from 'react'

import { ButtonSize, ButtonVariant, RoleTone, StyledButton } from './styles'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  variant?: ButtonVariant
  size?: ButtonSize
  fullWidth?: boolean
  loading?: boolean
  icon?: ReactNode
  tone?: RoleTone
}

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  loading = false,
  icon,
  tone = 'professor',
  disabled,
  type = 'button',
  ...props
}: ButtonProps) => (
  <StyledButton
    type={type}
    $variant={variant}
    $size={size}
    $fullWidth={fullWidth}
    $tone={tone}
    disabled={disabled || loading}
    aria-busy={loading}
    {...props}
  >
    {!loading && icon}
    {loading ? 'Cargando…' : children}
  </StyledButton>
)

export default Button
